import Grapnel from 'grapnel';
import interpolate from 'src/utils/interpolate';

const ROUTE_REGEX = /:([^:\/?]*)\??/g;
const ROOT_REGEX = /(\/[^\/]+\/[^\/]+)\/.*/;

class Router {
  constructor() {
    this.grapnel = new Grapnel({ pushState: true, root: this.getRoot() });
  }

  addListener(route, handler) {
    this.grapnel.get(route, handler);
  }

  navigate(route, options = {}, queryParams = location.search) {
    const parsedRoute = this.parse(route, options);
    this.grapnel.navigate(parsedRoute + queryParams);
  }

  replacePath(route, options = {}, queryParams = location.search) {
    const parsedRoute = this.parse(route, options);
    const root = this.getRoot();
    return window.history.replaceState({}, '', root + parsedRoute + queryParams);
  }

  setPath(route, options = {}, queryParams = location.search) {
    const parsedRoute = this.parse(route, options);
    return this.grapnel.path(parsedRoute + queryParams);
  }

  getPath() {
    return this.grapnel.path();
  }

  getRoot() {
    const result = ROOT_REGEX.exec(location.pathname);
    return result ? result[1] : location.pathname;
  }

  parse(route, options) {
    const parsedRoute = interpolate(route, options, ROUTE_REGEX);
    return parsedRoute.replace(/\/$/, '').replace(/\/\//g, '/');
  }
}

export default (new Router());
